import { render } from "./Footbar.vue?vue&type=template&id=32eff7dd&scoped=true"
import script from "./Footbar.vue?vue&type=script&lang=js"
export * from "./Footbar.vue?vue&type=script&lang=js"

import "./Footbar.vue?vue&type=style&index=0&id=32eff7dd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32eff7dd"]])

export default __exports__